// extracted by mini-css-extract-plugin
module.exports = {"root":"Map_root__fqB7q"};